import React, { useState, } from 'react';
import { Button, } from 'reactstrap';
import classnames from 'classnames';

import ImportMappingModal from './modals/ImportMappingModal';

export default function ImportMappingButton({
  label = 'インポート',
  fields,
  onImport,
  encoding = 'Shift_JIS',
  storageKey,
  disabled = false,
  ...extraProps
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(x => !x);

  return (
    <>
      <Button color="secondary" outline onClick={toggle} disabled={disabled} {...extraProps}>
        <span className={classnames('fas fa-upload', { 'me-1': !!label })} />
        {label}
      </Button>
      <ImportMappingModal
        isOpen={isOpen}
        toggle={toggle}
        fields={fields}
        onImport={onImport}
        encoding={encoding}
        storageKey={storageKey}
      />
    </>
  );
}
